// extracted by mini-css-extract-plugin
module.exports = {"theme":"#1960fb"};